import { render, staticRenderFns } from "./leads-list-table.vue?vue&type=template&id=106395a8"
import script from "./leads-list-table.vue?vue&type=script&lang=js"
export * from "./leads-list-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports